<div class="flex justify-between items-center ml-[5px] {{ noTitleMargin ? '' : 'mb-[20px]' }}">
  <div class="flex items-center">
    @if (faClass) {
      <i class="{{ faClass }} text-blue text-4xl mr-[10px]"></i>
    }
    @if (cardTitle) {
      <span class="text-3xl font-bold">{{ cardTitle }}</span>
    }
  </div>
  <div>
    <ng-content select="[header]"></ng-content>
  </div>
</div>

<ng-content></ng-content>
